// frontend/src/components/KeySelectModal.js
import React from 'react';
import '../styles/common/Modal.css';
import Modal from './common/Modal';
import { Circleof5thPanel } from './Circleof5thPanel';
import useLocale from '../hooks/useLocale';

const KeySelectModal = ({ isOpen, onClose, onSelect, currentKey }) => {
  const locale = useLocale();
  if (!isOpen) return null;

  const handleSelect = (key) => {
    if (onSelect) onSelect(key);
    if (onClose) onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} contentClassName="key-select-modal modal-content--modern">
        <h2>{locale === 'ja' ? 'Keyを選択' : 'Select Key'}</h2>
        <Circleof5thPanel
          selectedKey={currentKey}
          onSelect={handleSelect}
        />
        <div className="modal-buttons">
          <button type="button" onClick={onClose}>
            {locale === 'ja' ? '閉じる' : 'Close'}
          </button>
        </div>
    </Modal>
  );
};

export default KeySelectModal;
